import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="countdown-timer"
export default class extends Controller {
  static values = { expiresAt: String }

  connect() {
    this.expiresAt = new Date(this.expiresAtValue)
    this.updateCountdown()
    this.timer = setInterval(() => {
      this.updateCountdown()
    }, 1000)
  }

  disconnect() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  }

  updateCountdown() {
    const now = new Date()
    const timeLeft = this.expiresAt - now

    if (timeLeft <= 0) {
      this.element.textContent = 'Expiré'
      this.element.className = 'text-red-600 font-bold'
      if (this.timer) {
        clearInterval(this.timer)
      }
      return
    }

    const hours = Math.floor(timeLeft / (1000 * 60 * 60))
    const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000)

    this.element.textContent = `${hours}h ${minutes}m ${seconds}s`
  }
}